import { _ } from "libs";

import React, { useEffect, useState } from "react";
import withRedux from "../withRedux";
import ClubsList from "./clubsList";
import { loadFavorites } from "../actions";

const FavoriteClubs = ({ favorites, loadFavorites }) => {
	useEffect(() => {
		if (!favorites) {
			loadFavorites();
		}
	}, []);

	if (!favorites || favorites.length == 0) {
		return null;
	}

	return (
		<div className="dBlock">
			<h5>{_("favoriteClubsWidget.heading")}</h5>
			<ClubsList clubs={favorites || []} />
		</div>
	);
};

function mapStateToProps({ clubs: { favorites } }) {
	return { favorites };
}
export default withRedux({ loadFavorites }, mapStateToProps)(FavoriteClubs);
